// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // apiUrl:'http://13.232.213.9:8004'
  apiUrl: 'https://api.daktarz.com',
  firebase: {
    apiKey: "AIzaSyDy3n45RiQb1NwdnLyymjiUQzInvcdOVUw",
    authDomain: "daktarz-79a45.firebaseapp.com",
    projectId: "daktarz-79a45",
    storageBucket: "daktarz-79a45.appspot.com",
    messagingSenderId: "658491735843",
    appId: "1:658491735843:web:2daf1e27d5975434a29696",
    measurementId: "G-2J0VRK0KWX"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
